<template>
  <a-modal
    :title="title"
    centered
    :visible="visible"
    :mask-closable="false"
    :width="810"
    :body-style="{ padding: '15px' }"
    :ok-button-props="{ props: { disabled: !valid } }"
    cancel-text="Cerrar"
    ok-text="Enviar"
    @cancel="close"
  >
    <div class="row">
      <div class="col-12">
        <a-form-item
          :validate-status="validTo.state"
          has-feedback
          label="Destinatarios"
        >
          <a-select
            v-model="to"
            mode="tags"
            class="w-100"
            :token-separators="[',', ';', ' ']"
            not-found-content=""
          />
        </a-form-item>

        <g-field
          v-if="scope === null"
          v-model="department"
          app="reviews"
          name="department"
          title="Departamento"
        />

        <a-form-item label="Asunto">
          <a-input
            v-model="subject"
            :placeholder="defaultSubject"
          />
        </a-form-item>

        <g-editor
          v-model="html"
          :mandatory="htmlMandatory"
          help-position="bottom"
        />
      </div>
    </div>

    <template slot="footer">
      <div class="d-flex">
        <a-button
          key="back"
          class="mr-2"
          @click="close"
        >
          Cerrar
        </a-button>
        <a-popconfirm
          title="Se enviará el email a los destinatarios ¿Estas seguro?"
          cancel-text="Cerrar"
          ok-text="Enviar"
          @confirm="() => send()"
        >
          <a-icon
            slot="icon"
            type="question-circle"
            class="text-warning"
          />
          <a-button
            key="submit"
            class="ml-auto"
            type="primary"
            :loading="workers > 0"
            :disabled="!valid"
          >
            Enviar
          </a-button>
        </a-popconfirm>
      </div>
    </template>
  </a-modal>
</template>

<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */

export default {
	name: 'MarasReviewsMailer',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		view: {
			type: String,
			required: true
		},
		scope: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			subject: 'Tu opinión es importante',
			defaultSubject: 'Tu opinión es importante',
			department: 0,
			to: [],
			workers: 0,
			html: '<h3><b>Encuesta de satisfacción</b></h3><p>Con el fin de ofrecerte el mejor servicio, te enviamos una encuesta para que nos facilites tu opinion acerca del servicio prestado.</p>'
		};
	},
	computed: {
		title() {
			if (this.scope) return 'Reenviar solicitud de encuesta';

			return 'Enviar solicitudes de encuesta';
		},
		valid() {
			if (this.validTo.pass) return true;
			return false;
		},
		validTo() {
			const result = {
				pass: false,
				state: 'error'
			};

			if (this.to.length > 0) {
				result.pass = true;
				result.state = 'success';
			}

			this.to.forEach((val) => {
				const valid = this.validEmail(val);
				if (!valid) {
					result.pass = false;
					result.state = 'error';
				}
			});

			return result;
		},
		htmlMandatory() {
			return `<center><a href="{{REVIEW_URL}}" style="background-color:blue;border-radius:5px;color:#ffffff;display:inline-block;font-family:Cabin, Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;line-height:45px;text-align:center;text-decoration:none;width:155px;-webkit-text-size-adjust:none;mso-hide:all;">Acceder</a></center><!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{REVIEW_URL}}" style="height:45px;v-text-anchor:middle;width:155px;" arcsize="15%" strokecolor="#ffffff" fillcolor="${this.$colors.primary}"><w:anchorlock/><center style="color:#ffffff;font-family:Cabin, Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;">Acceder</center></v:roundrect><![endif]-->`;
		}
	},
	watch: {
		workers(newVal, oldVal) {
			if (oldVal > 0 && newVal === 0) {
				this.close();
			}
		}
	},
	methods: {
		close() {
			this.to = [];
			this.workers = 0;
			this.subject = this.defaultSubject;
			this.department = 0;
			this.html = '<h3><b>Encuesta de satisfacción</b></h3><p>Con el fin de ofrecerte el mejor servicio, te enviamos una encuesta para que nos facilites tu opinión acerca del servicio prestado.</p>';

			this.$emit('close');
		},
		async send() {
			if (this.valid && this.workers === 0) {
				const self = this;

				this.workers = this.to.length;

				if (this.scope) {
					// Generate review access url
					const htmlMandatory = self.htmlMandatory.replace(/\{\{REVIEW_URL\}\}/g, `${self.$app.paths.lambda}/review/${this.scope._EntityId}/${this.scope.token}`);

					self.$gestios.emails.send({
						email: this.to.join(','),
						subject: self.subject ? self.subject : self.defaultSuject,
						folder: 'encuestas',
						replyto: 'info@maras.es',
						message: this.html + htmlMandatory
					}).then((m) => {
						self.$gestios.items('reviews').edit({ id: this.scope._EntityId, params: { email: m.data.ID } });

						self.$message.success('Se reenvió la encuesta por email 😄');
						self.workers = 0;
					}).catch((err) => {
						self.$message.error('No se pudo enviar la encuesta por email');
						self.workers = 0;
					});
				} else {
					for (const mail of this.to) {
						const params = {
							client_mail: mail,
							department: this.department,
							competency: 1,
							q_filled: 0
						};

						// Add review
						self.$gestios
							.items('reviews')
							.add({ params, view: self.view })
							.then((r) => {
								// Generate review access url
								const htmlMandatory = self.htmlMandatory.replace(/\{\{REVIEW_URL\}\}/g, `${self.$app.paths.lambda}/review/${r.data._EntityId}/${r.data.token}`);

								// Send email
								self.$gestios.emails.send({
									email: mail,
									subject: self.subject ? self.subject : self.defaultSubject,
									folder: 'encuestas',
									replyto: 'info@maras.es',
									message: this.html + htmlMandatory
								}).then((m) => {
									self.$gestios.items('reviews').edit({ id: r.data._EntityId, params: { email: m.data.ID } });

									self.$message.success(`Se envió la encuesta por email a ${mail} 😄`);
									self.workers -= 1;
								}).catch((err) => {
									self.$message.error(`No se pudo enviar la encuesta por email a ${mail}`);
									self.workers -= 1;
								});
							})
							.catch(() => {
								self.$message.error(`No se pudo crear la encuesta para el email ${mail}`);
								self.workers -= 1;
							});
					}
				}
			} else {
				this.message.error('Revisa que las direcciones especificadas de email son correctas');
			}
		},
		validEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}
	}
};
</script>

<style lang="scss" module>
// @import "./style.module.scss";
</style>
